import { render, staticRenderFns } from "./HtAvatar.vue?vue&type=template&id=140af9a6&scoped=true&"
import script from "./HtAvatar.vue?vue&type=script&lang=js&"
export * from "./HtAvatar.vue?vue&type=script&lang=js&"
import style0 from "./HtAvatar.vue?vue&type=style&index=0&id=140af9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140af9a6",
  null
  
)

export default component.exports